<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="" v-if="activePrompt" style="width: 100%">
    <div>
      <h3>{{ getTitle }}</h3>
      <form>
        <vs-row class="mt-4 mb-4">
          <vs-col class="label" vs-w="2">
            <span>Question</span>
          </vs-col>
          <vs-col class="" vs-w="10">
            <vx-card class="w-full">
              <vs-input
                v-validate="'required'"
                name="question"
                placeholder="eg. How does adrenaline work?"
                class="w-full"
                v-model="taskLocal.question"
                :color="validateForm ? 'success' : 'danger'"
                @input="changeQuestion"
              />
            </vx-card>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4 mb-4">
          <vs-col class="label" vs-w="2">
            <span>Question type</span>
          </vs-col>
          <vs-col class="" vs-w="10">
            <vx-card class="w-full">
              <vs-radio
                v-model="taskLocal.qtype"
                vs-value="multiple-select"
                class="p-2"
                >Multiple select</vs-radio
              >
              <vs-radio
                v-model="taskLocal.qtype"
                vs-value="single-select"
                class="p-2"
                >Single select</vs-radio
              >
              <vs-radio
                v-model="taskLocal.qtype"
                vs-value="boolean"
                class="p-2"
                @change="selectBoolean"
                >True/False</vs-radio
              >
            </vx-card>
          </vs-col>
        </vs-row>
        <vs-row
          v-if="taskLocal.qtype == 'multiple-select' && all_data.length != 0"
        >
          <vs-col vs-w="2" class="label">
            <span>Next Question</span>
          </vs-col>
          <vs-col class="" vs-w="10">
            <vx-card class="w-full">
              <v-select
                :clearable="false"
                :options="getNextQuestion"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                placeholder="Select next question"
                class="w-full"
                v-model="taskLocal.next_question_if_answered"
                :color="validateForm ? 'success' : 'danger'"
              />
            </vx-card>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4 mb-4">
          <vs-col class="label" vs-w="2">
            <span>Options</span>
          </vs-col>
          <vs-col class="" vs-w="10">
            <vx-card class="w-full">
              <div
                class="mb-2"
                :key="index"
                v-for="(item, index) in taskLocal.options"
              >
                <vs-row vs-display="flex" vs-justify="space-around">
                  <!-- <vs-col class="" vs-w="2">
                    <span>Option {{ index + 1 }}</span>
                  </vs-col> -->
                  <vs-col class="" vs-w="11">
                    <vs-row>
                      <vs-col class="">
                        <vs-input
                          :placeholder="'Option ' + (index + 1)"
                          class=""
                          v-model="taskLocal.options[index].text"
                          :color="validateForm ? 'success' : 'danger'"
                           @input="changeOptionText(taskLocal.options[index].text,index)"
                        />
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col
                        v-if="
                          taskLocal.qtype != 'multiple-select' &&
                          all_data.length != 0
                        "
                      >
                        <span class="fs-12">Next Question</span>
                      </vs-col>
                      <vs-col class="">
                        <v-select
                          v-if="
                            taskLocal.qtype != 'multiple-select' &&
                            all_data.length != 0
                          "
                          :clearable="false"
                          :options="getNextQuestion"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          placeholder="Select next question"
                          class=""
                          v-model="
                            taskLocal.options[index].next_question_if_answered
                          "
                          :color="validateForm ? 'success' : 'danger'"
                          @input="changeSelect"
                        />
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-w="1" vs-display="flex" style="align-self: center">
                    <feather-icon
                      @click.stop="deleteOptions(index)"
                      v-if="taskLocal.options.length > 1"
                      icon="MinusCircleIcon"
                      svgClasses="w-6 h-6 hover:text-danger stroke-current"
                      class="ml-2 cursor-pointer"
                    />
                  </vs-col>
                </vs-row>
                <div
                  v-if="index != taskLocal.options.length - 1"
                  class="border-div"
                ></div>
              </div>
            </vx-card>
          </vs-col>
        </vs-row>
        <div class="add-new text-right">
          <vs-button
            class="w-small add-new-btn"
            @click="addNewOption"
            size="small"
            >Add New</vs-button
          >
        </div>
        <vs-row class="mt-4 mb-4">
          <vs-col class="label" vs-w="2">
            <span>Required</span>
          </vs-col>
          <vs-col class="" vs-w="10">
            <vx-card class="w-full">
              <vs-radio v-model="taskLocal.required" vs-value="yes" class="p-2"
                >Yes</vs-radio
              >
              <vs-radio v-model="taskLocal.required" vs-value="no" class="p-2"
                >No</vs-radio
              >
            </vx-card>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col class="text-right mb-4 mr-8">
            <vs-button class="save-btn" @click="addTodo">Save</vs-button>
            <vs-button class="cancel-btn ml-2" @click="cancelAdd"
              >Cancel</vs-button
            >
          </vs-col>
        </vs-row>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DataProvider from "../../../services/data-provider";
import { bus } from "../../../main";

export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    all_data: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
    },
    activePrompt: {
      type: Boolean,
    },
  },
  created() {
    bus.$on("edit_questionnaire2", (data, questions) => {
      console.log(data);
      this.edit_data = data;
      this.taskLocal.id = data.id;
      this.taskLocal.question = data.question;
      this.taskLocal.qtype = data.qtype;
      if (data.qtype == "multiple-select") {
        for (let j = 0; j < this.all_data.length; j++) {
          if (
            data.next_question_if_answered &&
            this.all_data[j].id == data.next_question_if_answered
          ) {
            this.taskLocal.next_question_if_answered = {
              value: data.next_question_if_answered,
              label: data.next_question_if_answered
                ? "(" +
                  data.next_question_if_answered +
                  ") - " +
                  this.all_data[j].question
                : "",
            };
          }
          if (
            data.next_question_if_answered == "" ||
            data.next_question_if_answered == null
          ) {
            this.taskLocal.next_question_if_answered = {
              value: data.next_question_if_answered,
              label: "",
            };
          }
        }
        this.taskLocal.options = data.options;
      } else {
        let temp_op = [];
        console.log(data.options);
        console.log(this.all_data);
        for (let i = 0; i < data.options.length; i++) {
          for (let j = 0; j < this.all_data.length; j++) {
            // data.options.filter((res) => {
            //   this.all_data.filter((que) => {
            if (
              data.options[i].next_question_if_answered &&
              this.all_data[j].id == data.options[i].next_question_if_answered
            ) {
              temp_op.push({
                text: data.options[i].text,
                next_question_if_answered: {
                  value: data.options[i].next_question_if_answered,
                  label: data.options[i].next_question_if_answered
                    ? "(" +
                      data.options[i].next_question_if_answered +
                      ") - " +
                      this.all_data[j].question
                    : "",
                },
                previous_question_id: data.options[i].previous_question_id,
              });
            } else {
              // temp_op.push({
              //   text: data.options[i].text,
              //   next_question_if_answered: {
              //     value: data.options[i].next_question_if_answered,
              //     label: data.options[i].next_question_if_answered
              //       ? "(" +
              //         data.options[i].next_question_if_answered +
              //         ") - " +
              //         this.all_data[j].question
              //       : "",
              //   },
              //   previous_question_id: data.options[i].previous_question_id,
              // });
            }
          }
          if (
            data.options[i].next_question_if_answered == "" ||
            data.options[i].next_question_if_answered == null
          ) {
            temp_op.push({
              text: data.options[i].text,
              next_question_if_answered: {
                value: data.options[i].next_question_if_answered,
                label: "",
              },
              previous_question_id: data.options[i].previous_question_id
                ? data.options[i].previous_question_id
                : "",
            });
          }
          if (i == data.options.length - 1) {
            console.log(temp_op);
            this.taskLocal.options = temp_op;
          }
        }
      }

      // this.taskLocal.options = data.options;
      this.taskLocal.required = data.required;
      this.activePrompt = true;
      this.is_edit = true;
      this.all_data = questions;
      this.item_data_temp = data.options;
      console.log(" this.taskLocal:", this.taskLocal);
    });
    bus.$on("edit_cancel", (data) => {
      console.log(data);
      this.is_edit = data;
      this.clearFields();
    });
  },
  data() {
    return {
      is_edit: false,
      all_questions: [],
      item_data_temp: "", // store post data
      old_question: "", //store old queston for check while update
      edit_data: "",
      taskLocal: {
        question: "",
        qtype: "",
        options: [
          { text: "", next_question_if_answered: "", previous_question_id: "" },
        ],
        required: "",
        id: "",
        next_question_if_answered: "",
      },
    };
  },
  computed: {
    getNextQuestion() {
      if (this.all_data) {
        let options = [];
        let all_options_id = [];
        for (let i = 0; i < this.all_data.length; i++) {
          if (this.all_data[i].next_question_if_answered) {
            all_options_id.push(this.all_data[i].next_question_if_answered);
          }
          for (let j = 0; j < this.all_data[i].options.length; j++) {
            if (this.all_data[i].options[j].next_question_if_answered) {
              all_options_id.push(
                this.all_data[i].options[j].next_question_if_answered
              );
            }
          }
          if (i == this.all_data.length - 1) {
            let data = [];
            if (this.edit_data) {
              if (this.edit_data.next_question_if_answered) {
                console.log(
                  "pop 1111",
                  this.edit_data.next_question_if_answere
                );
                // all_options_id.push(this.edit_data.next_question_if_answered);
                const index = all_options_id.indexOf(
                  this.edit_data.next_question_if_answered
                );
                if (index > -1) {
                  all_options_id.splice(index, 1);
                }
              }
              if (this.edit_data.qtype != "multiple-select") {
                this.edit_data.options.filter((itm) => {
                  if (itm.next_question_if_answered)
                    console.log("pop 22222", itm.next_question_if_answered);

                  // all_options_id.push(itm.next_question_if_answered);
                  const index = all_options_id.indexOf(
                    itm.next_question_if_answered
                  );
                  if (index > -1) {
                    all_options_id.splice(index, 1);
                  }
                });
              }
            }
            for (let k = 0; k < this.all_data.length; k++) {
              console.log("all_options_id:::", all_options_id);
              if (
                !all_options_id.includes(this.all_data[k].id) &&
                this.taskLocal.options.some((el) =>
                  el.next_question_if_answered
                    ? el.next_question_if_answered.value != this.all_data[k].id
                    : true
                )
              ) {
                if (this.all_data[k].question) {
                  options.push({
                    label:
                      this.taskLocal.qtype == "multiple-select"
                        ? "(" +
                          this.all_data[k].id +
                          ") - " +
                          this.all_data[k].question
                        : "(" +
                          this.all_data[k].id +
                          ") - " +
                          this.truncate(this.all_data[k].question, 10),
                    value: this.all_data[k].id,
                  });
                }
              }
              if (k == this.all_data.length - 1) {
                console.log("options:", options);
                let options_arr = options.filter((item) => {
                  let found = this.taskLocal.options.some((el) =>
                    el.next_question_if_answered && item
                      ? el.next_question_if_answered.value == item.value
                      : false
                  );
                  if (!found) {
                    return item;
                  }
                });
                console.log(options_arr);
                return options_arr;
                // return options;
              }
            }
          }
        }
        // let options = this.all_data.map((item) => {
        //   return {
        //     label:
        //       "(" + item.id + ")-" + item.question.substring(0, 10) + "...",
        //     value: item.id,
        //   };
        // });
        // console.log(options);
        // return options;
      }
    },
    getTitle() {
      return this.is_edit ? "Edit Question" : "Add Question";
    },
    taskTags() {
      return this.$store.state.todo.taskTags;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.taskLocal.question != "" &&
        this.taskLocal.qtype != "" &&
        (this.taskLocal.qtype == "multiple-select"
          ? this.taskLocal.next_question_if_answered != ""
          : this.taskLocal.options.length != 0)
      );
    },
  },
  methods: {
    clearFields() {
      console.log("clearFields");
      Object.assign(this.taskLocal, {
        question: "",
        qtype: "",
        options: [{ text: "", next_question_if_answered: "" }],
        required: "",
        id: "",
        next_question_if_answered: "",
        // status: "draft",
      });
      this.is_edit = false;
      this.all_questions = [];
      this.old_question = "";
      this.edit_data = "";
    },
    changeSelect(e) {
      console.log("changeSelect",e);
      console.log("this.", this.taskLocal.options)
    },
    changeOptionText(e,i){
      console.log("changeOptionText",e);
      console.log("changeOptionText",i);
      this.$emit("changeOptionText", {text:e,index:i});


    },
    cancelAdd() {
      // console.log(
      //   "edit_questionnaire2:",
      //   this.$store.getters.getAllQuestionnaire
      // );

      this.$emit("cancel", this.taskLocal.id);
    },
    selectBoolean() {
      console.log("selectBoolean");
      this.taskLocal.options = [
        { text: "Yes", next_question_if_answered: "" },
        { text: "No", next_question_if_answered: "" },
      ];
    },
    changeQuestion(e) {
      console.log("changeQQ:", e);
      this.$emit("changeQuestion", e);
    },
    deleteOptions(i) {
      this.taskLocal.options.splice(i, 1);
    },
    addNewOption() {
      this.taskLocal.options.push({
        text: "",
        next_question_if_answered: "",
        previous_question_id: "",
      });
    },
    truncate(str, no_words) {
      return str.split(" ").splice(0, no_words).join(" ");
    },
    addTodo() {
      console.log("this.taskLocal:", this.taskLocal);
      this.$vs.loading();

      this.taskLocal.options = this.taskLocal.options.map((item) => {
        this.all_data.filter((res, index) => {
          console.log("item:::::",item.next_question_if_answered &&
            item.next_question_if_answered.value == res.id)
          if (
            item.next_question_if_answered &&
            item.next_question_if_answered.value == res.id
          ) {
            this.all_data[index].options.filter((data, i) => {
              // console.log("data")
              this.all_data[index].options[i].previous_question_id = this
                .all_data
                ? this.all_data[this.all_data.length - 1].id + 1
                : 1;
            });
          } else if (
            this.taskLocal.qtype == "multiple-select" &&
            this.taskLocal.next_question_if_answered &&
            this.taskLocal.next_question_if_answered.value == res.id
          ) {
            console.log("multiple-select:::");
            this.all_data[index].options.filter((data, i) => {
              // console.log("data")
              this.all_data[index].options[i].previous_question_id = this
                .all_data
                ? this.all_data[this.all_data.length - 1].id + 1
                : 1;
            });
          }
        });
        return {
          text: item.text,
          next_question_if_answered:
            this.all_data.length==0 || item.next_question_if_answered == ""
              ? null
              : item.next_question_if_answered
              ? item.next_question_if_answered.value
              : "",
        };
      });
      console.log("all_questionnaire", this.taskLocal);
      let question_data = {
        question: this.taskLocal.question,
        type: "question",
        qtype: this.taskLocal.qtype,
        options: this.taskLocal.options,
        required: this.taskLocal.required,
        id: this.taskLocal.id,
      };
      this.all_data.map((v) => delete v.is_collapse);
      if (question_data.qtype == "multiple-select") {
        console.log("next_question_if_answered", this.taskLocal);
        question_data.next_question_if_answered = this.taskLocal.next_question_if_answered.hasOwnProperty(
          "value"
        )
          ? this.taskLocal.next_question_if_answered.value
          : this.taskLocal.next_question_if_answered;
      }
      if (this.is_edit == false) {
        question_data.id =
          this.all_data.length != 0
            ? this.all_data[this.all_data.length - 1].id + 1
            : 1;
      } else {
        console.log("question_data", question_data);
        this.all_data.filter((data, i) => {
          // console.log("data")
          if (data.id == question_data.id) {
            this.all_data[i].question = question_data.question;
            this.all_data[i].qtype = question_data.qtype;
            this.all_data[i].next_question_if_answered =
              question_data.next_question_if_answered;
            this.all_data[i].options = question_data.options;
            this.all_data[i].required = question_data.required;
          }
        });
      }

      console.log(this.all_data);

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.is_edit == false) {
            this.all_data.push(question_data);
            console.log(this.all_data);
            if (this.all_data.length == 1) {
              DataProvider.addDataQuestionnaire(
                "onboarding_questionnaire",
                question_data,
                this.all_data
              ).then(
                (data) => {
                  this.$vs.loading.close();
                  console.log("Data:", data);
                  this.$emit("reloadItems");
                  this.$emit("cancel", false);
                  this.clearFields();
                },
                (error) => {
                  DataProvider.sendSentryErrorLog(err)
                  this.$vs.loading.close();
                }
              );
            } else {
              DataProvider.updateFirestoreCloudData(
                "/all_onboarding_questionnaire/",
                this.all_data
              ).then(
                (data) => {
                  this.$vs.loading.close();
                  console.log("Data:", data);
                  this.$emit("reloadItems");
                  this.$emit("cancel", false);
                  this.clearFields();
                },
                (error) => {
                  DataProvider.sendSentryErrorLog(err)
                  this.$vs.loading.close();
                }
              );
            }
          } else {
            console.log("edit this.all_data", this.all_data);
            DataProvider.updateFirestoreCloudData(
              "/all_onboarding_questionnaire/",
              this.all_data
            ).then(
              (data) => {
                this.$vs.loading.close();
                console.log("Data:", data);
                this.$emit("reloadItems");
                this.$emit("cancel", false);
                this.clearFields();
              },
              (error) => {
                DataProvider.sendSentryErrorLog(err)
                this.$vs.loading.close();
              }
            );
          }
        }
      });
    },
    generateUUID() {
      var d = new Date().getTime();
      var uuid = "x".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
  },
};
</script>
<style scoped>
.add-new-btn {
  border-radius: 25px;
}
.label {
  padding-top: 0.8rem !important;
}
.fs-12 {
  font-size: 13px;
}
.border-div {
  height: 20px;
  border-bottom: 1px solid #b1b1b1;
}
</style>
